import { Stack } from '@mui/material';
import styled from 'styled-components';

export const OffboardingAlertContainer = styled(Stack)`
  && {
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
    padding: 0.375rem 0.75rem;
    border-radius: ${({ theme }) => theme.shape.buttonRadius.large};
    height: 3.25rem;
    background-color: ${({ theme }) => theme.palette.status.red.background};
    border: 1px solid ${({ theme }) => theme.palette.status.red.stroke};

    p {
      color: ${({ theme }) => theme.palette.status.red.text};
    }
  }
`;
